import { gql } from "apollo-boost"

export const CREATE_MINISTRATION_PERIOD = gql`
  mutation createMinistrationPeriod(
    $createMinistrationPeriod: CreateMinistrationPeriodInput!,
    $ministrationPlanId: ID!)
  {
    CreateMinistrationPeriod(
      ministrationPlanId: $ministrationPlanId,
      CreateMinistrationPeriod: $createMinistrationPeriod
    ) {
      id
      createdAt
      deletedAt
      modifiedAt
      orderIndex
      revisionDueDate
      revisionStartDate
      revisionEndDate
      ministrationDueDate
      ministrationStartDate
      ministrationEndDate
      ministrationBudget {
        id
        createdAt
        deletedAt
        modifiedAt
        implementer
        alliedOne
        alliedTwo
        ficosec
      }
    }
  }
`
